import React from 'react';
import { Puff } from 'react-loader-spinner';

import { remCss, scssVariables as variables, lang } from 'src/helpers';

const Spinner = React.memo(
  ({ justifyContent = 'center', color, size = 20, containerStyles = {} }) => (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        flexGrow: 1,
        ...containerStyles
      }}
    >
      <div
        className={'mc-flex'}
        style={{
          justifyContent,
          backgroundColor: color || variables['colors-mc-primary'],
          color: '#fff',
          padding: remCss(10),
          width: remCss(150),
          borderRadius: remCss(5)
        }}
      >
        <Puff color={'#fff'} height={remCss(size)} width={remCss(size)} />
        {lang.t('Loading')}...
      </div>
    </div>
  )
);


Spinner.displayName = 'Spinner';

export default Spinner;
